import { Driver, DriverGender } from 'scenes/motor/types';

export const defaultDriver: Driver = {
  firstName: '',
  lastName: '',
  gender: DriverGender.Unspecified,
  dob: '',
  yearsDriving: -1,
  claimsMade: -1,
  payableClaims: -1,
};
